function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepCardTemplate = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _CardActions = require("../CardActions");
var _StepCard = require("../StepCard");
var StepButtons = _interopRequireWildcard(require("../StepButtons"));
var _Button = require("../Button");
var _models = require("../../models");
var _styles = require("./styles");
var _reactI18next = require("react-i18next");
var _locales = require("../../locales");
var _styles2 = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["action", "commitmentState", "style", "categoryPillOnPress", "isCardContentCentred", "hideSuppress", "hideExisting", "hideAbandon"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var StepCardTemplate = exports.StepCardTemplate = (0, _react.memo)(function (_ref) {
  var _action$themes;
  var action = _ref.action,
    commitmentState = _ref.commitmentState,
    style = _ref.style,
    categoryPillOnPress = _ref.categoryPillOnPress,
    isCardContentCentred = _ref.isCardContentCentred,
    _ref$hideSuppress = _ref.hideSuppress,
    hideSuppress = _ref$hideSuppress === void 0 ? false : _ref$hideSuppress,
    _ref$hideExisting = _ref.hideExisting,
    hideExisting = _ref$hideExisting === void 0 ? false : _ref$hideExisting,
    _ref$hideAbandon = _ref.hideAbandon,
    hideAbandon = _ref$hideAbandon === void 0 ? false : _ref$hideAbandon,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _locales.useStepLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useContext = (0, _react.useContext)(_utils.LinkContext),
    stepDetailPageLinkUrl = _useContext.stepDetailPageLinkUrl;
  var _useContext2 = (0, _react.useContext)(_utils.AuthContext),
    isAuthenticated = _useContext2.isAuthenticated;
  var _useContext3 = (0, _react.useContext)(_utils.AnalyticsSourceContext),
    source = _useContext3.source;
  var _useGikiAnalytics = (0, _utils.useGikiAnalytics)(),
    saveGikiAnalyticsEvent = _useGikiAnalytics.saveGikiAnalyticsEvent,
    GikiAnalyticsEventType = _useGikiAnalytics.GikiAnalyticsEventType;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors;
  var _buttonSize = _Button.ButtonSize.normal;
  var _hasCommitmentState = !!commitmentState;
  var _isCompleted = _hasCommitmentState && (0, _utils.isCommitmentStateCompleted)(commitmentState);
  var _isPending = commitmentState === _models.CommitmentState.pending;
  var _showCommit = isAuthenticated && !_isCompleted && !_isPending;
  var _hasSuppress = _showCommit && !hideSuppress;
  var _useStyles = (0, _styles.useStyles)({
      isCentred: isCardContentCentred,
      showCommit: _showCommit
    }),
    styles = _useStyles.styles;
  var _primaryActionLink = stepDetailPageLinkUrl && action ? (0, _utils.ReplaceParam)(stepDetailPageLinkUrl, action.param) : undefined;
  var _highlightedButtonStyles = action != null && action.isHighlighted ? {
    backgroundColor: colors.highlightedCardButtonBackground,
    color: colors.highlightedCardButtonText
  } : undefined;
  var _primaryActionTrackingOnPress = function _primaryActionTrackingOnPress() {
    if (!(action != null && action.id)) return;
    saveGikiAnalyticsEvent({
      event: GikiAnalyticsEventType.stepCard,
      source: source,
      content: action.id
    });
  };
  if (!action) {
    return null;
  }
  return (0, _jsxRuntime.jsx)(_StepCard.StepCard, Object.assign({
    testID: "StepCardTemplate",
    title: action.summary,
    themes: (_action$themes = action.themes) == null ? void 0 : _action$themes.map(function (themeItem) {
      return themeItem.theme;
    }),
    impact: action.impact,
    style: [styles.stepCard, style],
    primaryActionLabel: t('step:buttons.learnMoreAbout', {
      value: action.summary
    }),
    primaryActionLink: _primaryActionLink,
    primaryActionTrackingOnPress: _primaryActionTrackingOnPress,
    categoryPillOnPress: categoryPillOnPress,
    isCentred: isCardContentCentred,
    isHighlighted: action.isHighlighted,
    trackingContent: action == null ? void 0 : action.id,
    SecondaryAction: _hasSuppress ? (0, _jsxRuntime.jsx)(StepButtons.HideStep, {
      action: action,
      size: _Button.ButtonSize.small
    }) : undefined
  }, props, {
    children: (0, _jsxRuntime.jsxs)(_CardActions.CardActions, {
      isCentred: isCardContentCentred,
      children: [_showCommit && (0, _jsxRuntime.jsx)(StepButtons.Commit, {
        action: action,
        size: _buttonSize,
        containerStyle: styles.buttonContainerStyle,
        textStyle: [styles.buttonTextStyle, _highlightedButtonStyles]
      }), isAuthenticated && _isCompleted && !hideAbandon && (0, _jsxRuntime.jsx)(StepButtons.Abandon, {
        action: action,
        size: _buttonSize,
        containerStyle: styles.buttonContainerStyle,
        textStyle: [styles.buttonTextStyle, _highlightedButtonStyles]
      }), isAuthenticated && _isPending && (0, _jsxRuntime.jsx)(StepButtons.Succeed, {
        action: action,
        size: _buttonSize,
        containerStyle: styles.buttonContainerStyle,
        textStyle: [styles.buttonTextStyle, _highlightedButtonStyles]
      }), (0, _jsxRuntime.jsx)(StepButtons.LearnMore, {
        action: action,
        href: _primaryActionLink,
        size: _buttonSize,
        containerStyle: styles.buttonContainerStyle,
        textStyle: [styles.buttonTextStyle, _highlightedButtonStyles]
      }), _showCommit && !hideExisting && (0, _jsxRuntime.jsx)(StepButtons.Current, {
        action: action,
        size: _buttonSize,
        containerStyle: styles.buttonContainerStyle,
        textStyle: [styles.buttonTextStyle, _highlightedButtonStyles]
      })]
    })
  }));
});